var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.84 31.84"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clock_svg__cls-1{stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clock_svg__cls-1",
    d: "M15.92 0C7.13 0 0 7.13 0 15.92s7.13 15.92 15.92 15.92 15.91-7.13 15.92-15.92C31.84 7.13 24.71 0 15.92 0zm0 27.19c-6.23 0-11.27-5.05-11.27-11.28S9.69 4.64 15.92 4.64c6.22 0 11.27 5.05 11.28 11.27 0 6.23-5.05 11.28-11.28 11.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clock_svg__cls-1",
    d: "M18.57 17.91c0 .36-.28.66-.64.66H11.28c-.36 0-.66-.28-.66-.64v-1.35c0-.36.28-.66.64-.66H15.92v-7.3c0-.36.28-.66.64-.66h1.35c.36 0 .66.28.66.64V17.91z"
  })));
}

export default __webpack_public_path__ + "1aedcc1f345a31ce81076638f1c0c7be.svg";
export { SvgClock as ReactComponent };